"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Breadcrumb = _interopRequireDefault(require("./Breadcrumb"));

exports.default = _Breadcrumb.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/collections/Breadcrumb/index.js
// module id = 1452
// module chunks = 0